import React, { useEffect, useState } from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from './Breadcrumb'
import { Icon } from '@iconify/react/dist/iconify.js'

import JobsTable from './JobTable'
import { Link } from 'react-router-dom'
import DriverTable from './DriverTable'
import { Card, CardBody, Spinner } from 'react-bootstrap'
import { API_URL } from '..'

export default function DriversPage() {
  const [jobsData , setJobData] = useState([])
  const [Loading, setLoading] = useState(true)
  const getCurrentUser = async ()=>{
    const user = await localStorage.getItem('user');
    const value = JSON.parse(user)
    setLoading(true)

    let headersList = {
      Accept: "*/*",
      // "User-Agent": "Thunder Client (https://www.thunderclient.com)",
    };
   
    try { 
         let response = await fetch(`${API_URL}/api/driver/fetch/${value.id}`, {headers:headersList,method:'GET'});
         const data = await response.json();
         
         setJobData(data.data.reverse())
         setLoading(false)
      
    } catch (error) {
      setLoading(false)
      console.log(error.message)
    }
   
  }
useEffect(()=>{
    getCurrentUser()
},[1])
  return (
    <>
     <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Drivers" />
        {
          Loading === true ?
          <div className='text-center'>
            <Spinner/>
          </div>
          : null
        }
  {
    jobsData.length== 0   ? 
 null:
    <DriverTable jobsData={jobsData.reverse()}/> 
  }
  
    {
            jobsData.length === 0 && Loading === false  ? 
            <Card className="mt-20">
                <CardBody>
                    <p className="text-center">No Driver is created yet. <Link  to={'/add-driver'} className='text-primary'>Add New</Link></p>
                </CardBody>
            </Card> :null
        }

 
        </MasterLayout>
    </>
  )
}
